import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAuthContext } from "../../../AuthContextWrapper";
import { LARAVEL_APP_HOME, LARAVEL_APP_HOST } from "../../../constants";
import { Box, Button, Typography } from "@mui/material";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import paperPlane1 from "../../assets/paper-plane-1x.png";
import paperPlane15 from "../../assets/paper-plane-1.5x.png";
import paperPlane2 from "../../assets/paper-plane-2x.png";
import paperPlane3 from "../../assets/paper-plane-3x.png";
import { AssetContext } from "../../../AssetContextWrapper";
import { estateApi } from "../../../apis";
import { EstateJSON } from "../../../models/Estate";

export enum Outcomes {
  continue = "Continue",
}

interface Props {
  heading?: string;
}

export const CompleteScreen = ({ heading }: Props): JSX.Element => {
  const { flow, activeEstate } = useAuthContext()
  const { assetsLoaded } = useContext(AssetContext);
  const { screenName } = useParams();
  const currentScreen = flow?.getCurrentFlowScreen(screenName);
  const primaryRealEstate = activeEstate?.primaryRealEstate;

  useEffect(() => {
    (async () => {
      if(!activeEstate?.id) {
        return
      }

      await estateApi.updateEstate(activeEstate?.id, {
          primary_home_complete: true,
          country_id: activeEstate.countryId || undefined,
          state_id: activeEstate.stateId || undefined
        } as EstateJSON);
    })();
  }, [assetsLoaded, activeEstate?.id]);

  const handleComplete = async (): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    window.location.href = `${LARAVEL_APP_HOST}/home`;
    return true;
  };

  return currentScreen ? (
    <FlowScreenWrapper hideSectionHeading={true} centerContent={true}>
      <>
        <Box
          sx={{
            my: 2,
            textAlign: "center",
          }}
        >
          <img
            srcSet={`${paperPlane15} 1.5x, ${paperPlane2} 2x, ${paperPlane3} 3x`}
            src={paperPlane1}
            alt="Paper airplane"
            // style={{ height: "156px" }}
          />
        </Box>
        <Box
          sx={{
            my: 2,
            textAlign: "center",
          }}
        >
          <Typography component="h2" variant="h5">
            {heading || "Great job! Now let’s explore your Atticus dashboard"}
          </Typography>
          <Typography variant="body1" sx={{ mt: 1, mb: 4 }}>
            We’ll let you know if you need to provide any more information about
            {primaryRealEstate?.asset
              ? ` ${primaryRealEstate?.asset}`
              : " the home"}
            .
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            my: 6,
          }}
        >
          <Button
            variant="contained"
            onClick={() => handleComplete()}
            sx={{
              mb: 3,
            }}
          >
            Continue
          </Button>
        </Box>
      </>
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
